import api from './api';

const unwrap = (response) => response?.data?.data ?? response?.data;

const changeOrderService = {
  listForProject: async (projectId) => unwrap(await api.get(`/projects/${projectId}/change-orders`)),

  createDraft: async (projectId, payload) => unwrap(await api.post(`/projects/${projectId}/change-orders`, payload)),

  updateDraft: async (id, payload) => unwrap(await api.put(`/change-orders/${id}`, payload)),

  submit: async (id) => unwrap(await api.post(`/change-orders/${id}/submit`)),

  withdraw: async (id) => unwrap(await api.post(`/change-orders/${id}/withdraw`)),

  // signature: the payload object emitted by DigitalSignatureCapture's onSignatureComplete
  approve: async (id, signature) => unwrap(await api.post(`/change-orders/${id}/approve`, { signature })),

  requestChanges: async (id, comment) => unwrap(await api.post(`/change-orders/${id}/request-changes`, { comment })),

  decline: async (id, comment) => unwrap(await api.post(`/change-orders/${id}/decline`, { comment })),
};

export default changeOrderService;
